<template>
  <div class="content">
    
    <div class="right">
      
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <input
              v-model.trim="search.deviceCode"
              class="form-control"
              id
              type="text"
              placeholder="请输入设备编号"
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table v-loading="loading" element-loading-text="加载中..."
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="车场编号">
            <template slot-scope="scope">
              <span>{{
                scope.row.parkingId
                  ? JSON.parse(scope.row.parkingId).parkingName
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备编号"
            prop="deviceCode"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备类型"
           
          >臻时</el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备状态"
            prop="status"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <!-- <button type="button" class="edit" @click="correct(scope.row.id)">
                校准
              </button> -->
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
    <!-- 添加/编辑-->
    <el-dialog
      title="添加/编辑"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
    >
      <el-form
        label-position="right"
        :model="form"
        :label-width="formLabelWidth"
        ref="form"
        :rules="rules"
      >
        <el-form-item label="车场编号" prop="parkingId" >
          <el-col :span="18">
            <el-select
              class="check-parking"
              filterable
              clearable
              v-model="form.parkingId"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :value="item.parkingId"
                :label="item.parkingName"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="设备编号" prop="deviceCode">
          <el-col :span="18">
            <el-input v-model.trim="form.deviceCode"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";

import {
  requestIntellidataDeviceList,
  requestOneIntellidataDevice,
  requestAllAreaParking,
  requestCorrectIntellidataDevice,
  fetchParkigList,
} from "@/api/url";

import Page from "../../commons/page";

export default {
  data() {
    return {
      loading: false,
      parkingList: [],
      dialogFormVisible: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      formLabelWidth: "106px",

      form: {
        id: "",
        deviceCode: "",
        parkingId: "",
      },
      allAreaParkingData: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        deviceCode: "",
      },
      rules: {
        parkCode: [
          { required: true, message: "请选择停车场", trigger: "blur" },
        ],
        deviceCode: [
          { required: true, message: "请输入设备编号", trigger: "blur" },
        ],
      },
      tableListData: [],
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    permiss() {},
  },
  components: {
    Page,
  },
  created: function() {},
  mounted() {
    this.getAllParkingLot();
    this.tableList(this.search.pageNumber);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      //  if (!this.treeData.parkingId) {
      //     this.$message({
      //       message: "请选择车场",
      //       type: "warning"
      //     });
      //     return;
      //   }
      this.tableList(this.search.pageNumber);
    },
    getAllParkingLot() {
      this.$get(fetchParkigList()).then((data) => {
        if (data.status === 200) {
          this.parkingList = data.data;
        }
      });
    },
    addOrEdit: function(id) {
      this.dialogFormVisible = true;
      this.form.id = id;
      if (id) {
        this.$get(requestOneIntellidataDevice() + "/" + id, {}).then((data) => {
          if (data.status != 200) return this.$layer.msg(data.message);
          this.form.deviceCode = data.data.deviceCode;
          this.form.parkingId = data.data.parkingId;
        });
      } else {
        this.form.deviceCode = "";
        this.form.parkingId = "";
      }
    },

    addOrEditTrue: function() {
      var _this = this;
      this.$refs["form"].validate(function(valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(requestOneIntellidataDevice(), {
                deviceCode: _this.form.deviceCode,
                parkingId: _this.form.parkingId,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;

                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(
                requestOneIntellidataDevice() + "/" + _this.form.id,
                {
                  deviceCode: _this.form.deviceCode,
                  parkingId: _this.form.parkingId,
                  id: _this.form.id,
                }
              )
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);

                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },

    del: function(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);

          _this
            .$deleteRequest(requestOneIntellidataDevice() + "/" + id, {})
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.curIndex);
            });
        }
      );
    },

    tableList: function(curPage) {
      this.loading = true;
      var _this = this;
      this.$get(requestIntellidataDeviceList(), {
        limit: this.search.pageSize,
        page: curPage,
        deviceCode: this.search.deviceCode,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
},
    getAllAreaParking() {
      this.$get(requestAllAreaParking()).then((data) => {
        this.allAreaParkingData = data;
      });
    },

    searchList: function() {
      if (this.loading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    handleKeyupTime: function(e) {
      e.target.value = e.target.value.replace(/\D/g, "");
    },
    handleKeyup: function(e) {
      e.target.value = e.target.value.replace(
        /[ !`~\!@#\$%\^&\*()_+=\-\;\:\"\'\\/?,<>|\A-Za-z\u4e00-\u9fa5]+/g,
        ""
      );
    },
    correct(id) {
      this.$get(requestCorrectIntellidataDevice() + "/" + id).then((data) => {
        if (data.message == "成功") {
          this.$notify({
            type: "success",
            title: "成功",
            message: data.message,
          });
        } else {
          this.$notify.error({
            title: "失败",
            message: data.message,
          });
          return;
        }
      });
    },
  },

  watch: {},
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.el-input {
  display: inline-block;
  width: 200px;
}
.btns {
  margin: 20px auto 0;
  width: 150px;
}
.boxbgcolor {
  display: flex;
}

.area {
  width: 100%;

  display: inline-block;
}
.list {
  position: relative;
}

.list-right {
  padding-bottom: 100px !important; /* 为分页组件留出空间 */
  box-sizing: border-box;
}

.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}
</style>
